module.exports = __webpack_public_path__ + "img/wake-up.07e6188b.png";